import { useIntl } from 'gatsby-plugin-intl';
import React from 'react';

import Layout from '../components/Layout';
import SEO from '../components/seo';

function ContactPage() {
  const { formatMessage } = useIntl();

  return (
    <Layout>
      <SEO keywords={[`gatsby`, `tailwind`, `react`, `tailwindcss`]} title="Contact Us" />
      <section className="relative w-full xl:container px-4 sm:px-8 mx-auto py-24 md:py-64">
        <form className="mx-auto md:w-1/2">
          <h1 className="font-heading font-bold text-2xl w-full mb-12 text-center">
            {formatMessage({ id: 'contactPage.title' })}
          </h1>

          <input
            className="w-full mb-4 px-3 py-2 rounded border-2 focus:border-blue-900 border-blue-700 focus:outline-none"
            id="name"
            placeholder={formatMessage({ id: 'contactPage.name' })}
            type="text"
          />

          <input
            className="w-full mb-4 px-3 py-2 rounded border-2 focus:border-blue-900 border-blue-700 focus:outline-none"
            id="email"
            placeholder={formatMessage({ id: 'contactPage.email' })}
            type="email"
          />

          <textarea
            className="w-full mb-4 px-3 py-2 rounded border-2 focus:border-blue-900 border-blue-700 focus:outline-none"
            id="message"
            placeholder={formatMessage({ id: 'contactPage.message' })}
            rows="8"
          />

          <button className="px-4 py-2 text-sm font-bold text-white bg-gray-600 rounded hover:bg-gray-800">
            {formatMessage({ id: 'contactPage.send' })}
          </button>
        </form>
      </section>
    </Layout>
  );
}

export default ContactPage;
